import React, { Suspense, lazy } from 'react'; // Added React, Suspense, and lazy
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './App.less';
import './init';
import Dashboard from './components/dashboard/DashboardPage';
import Schedules from './components/schedule/Schedules';
// import {
//    Assessment, CreatePDF, CreateManual, EditPDF, EditManual, AnswerPDF, AnswerManual, EditAssignPDF, ViewPDF, ViewManual,
//    StudentAssessment, StudentViewPDF, StudentViewManual, Tracker, TeacherViewPDF, TeacherViewManual,
//    PreviewPDF, PreviewManual, AssessmentSubjects, StudentAssessmentSubjects,
//    FormativeAssessment, FormativeCreateManual, FormativeCreatePDF, FormativeEditManual, FormativeEditPDF,
//    FormativeAnswerManual, FormativeAnswerPDF, FormativePreviewManual, FormativePreviewPDF,
//    FormativeTracker, FormativeViewManual, StudentFormativeAssessment,
//    StudentFormativeViewManual, StudentFormativeViewPDF, TeacherFormativeViewPDF, TeacherFormativeViewManual, FormativeAssessmentSubjects,
//    StudentFormativeAssessmentSubjects, DiagnosticAssessmentReport
// } from './pages/AssessmentPage';
import {
   MasteryContents, MasteryCreate, MasteryEdit, MasteryPreview, MasteryPreviewPDF, MasteryPreviewManual,
   MasteryAssessment, MasteryCreatePDF, MasteryCreateManual, MasteryEditPDF, MasteryEditManual, MasteryStudyPlan, MasteryTracker,
   MasteryStudentAssessment, MasteryStudentPreview, MasteryTeacherViewPDF, MasteryTeacherViewManual, MasteryStudentViewPDF, MasteryStudentViewManual,
   MasteryStudentViewResult, MasteryAnswerPDF, MasteryAnswerManual, MasteryRecommendation, MasteryInstruction,
   MasteryAssessmentReport, MasteryReportType1, MasteryReportType2, MasteryReportType3, MasteryReportType4, MasteryReportType5,
   MasteryAssessmentSubject, MasterySubjects,
} from './pages/MasteryAssessmentPage';
// import { SubjectEdit, SubjectList, SubjectView, SubjectGroupings } from './pages/SubjectPage';
import { OnlineAppInfoGroups, OnlineAppInfoFields } from './pages/ManagementPage';
import { StudentEmergencyInfo } from './pages/EmergencyInfoPage';
import { Routes, Route, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import NoticeList from './components/notice-board/NoticeList';
import NoticeBoard from './components/notice-board/NoticeBoard';
import Login from './pages/LoginPage/Login';
import ForgotPassword from './pages/LoginPage/ForgotPassword';
import CreateNotice from './components/notice-board/create/CreateNotice';
import EditNotice from './components/notice-board/edit/EditNotice';
import { Homeworks, StudentHomeworks, HomeworkSubjects, Projects, ProjectSubjects, StudentHomeworkSubjects } from './pages/HomeworksPage';
import Profile from './components/profile/Profile';
import { ReportCards, StudentReportCards, Certificates, StudentCertificates } from './pages/ReportCardsPage';
import { StudentInfo, StaffInfo, PromoteStudents, Sections, Levels, Subjects, SubjectGroups, ConfigSettings } from './pages/ManagementPage';
import { ClassSchedule, LessonCalendar, SchoolCalendar } from './pages/SchedulePage';
import { SurveyAssign, Survey } from './pages/SurveyPage';
import { Attendance, ClassroomAttendance, ClassroomAttendanceReports, PeriodAttendance, PeriodAttendanceReport } from './pages/AttendancePage';
import { ApplicationList, ReviewApplication, Interview, StudentFees, StudentProfile, ApplicantListByBatch, ApplicantMER, ReviewMER } from './pages/ApplicationPage';
import SideMenuNew from './components/side-menu/SideMenuNew';
import SideMenuSmallScreenNew from './components/side-menu/SideMenuSmallScreenNew';
import { ChatGPTFB } from './components/chatGPT/ChatGPTFB';
// import LessonCreationForm from './components/lesson/createlesson/LessonCreationForm';
// import { LessonPage } from './pages/LessonPage2.0/hooks/LessonPage';
// import { LessonEditView } from './pages/LessonPage2.0/LessonEditView/LessonEditView';
import { Application } from './pages/ApplicationPage/Application';
import PrivacyPolicy from './pages/LoginPage/PrivacyPolicy';
import LessonViewerTest from './pages/LessonPage2.0/Viewer/LessonViewerTest';
import { SubjectGroupingsResources } from './pages/SubjectPage/SubjectGroupingsResources';
import {
   MicrocredentialsManagementPage,
   MicrocredentialsPerformanceTaskCoursesPage,
   MicrocredentialsPerformanceTaskPage,
   MicrocredentialsWrittenWorksCoursesPage,
   MicrocredentialsWrittenWorksPage,
   MicrocredentialsTeacherGuidePage,
   MicrocredentialsStudentPerformanceTaskPage,
   MicrocredentialsStudentPerformanceTaskSubjectsPage,
   MicrocredentialsStudentWrittenWorksPage,
   MicrocredentialsStudentWrittenWorksSubjectsPage
} from './pages/MicrocredentialsPage';

import Soa from './pages/SOAPage/Soa';
import { OldStudentAdmission } from './pages/ApplicationPage';
import NoticeBoardSlide from './components/notice-board/NoticeBoardSlide';
import { TvetFeatureUnavailable } from './components/tvet-tenant/TvetFeatureUnavailable';
import { getUnavailableFeature } from './misc/TvetTenant';

const SubjectEdit = lazy(() => import('./pages/SubjectPage').then(m => ({ default: m.SubjectEdit })));
const SubjectList = lazy(() => import('./pages/SubjectPage').then(m => ({ default: m.SubjectList })));
const SubjectView = lazy(() => import('./pages/SubjectPage').then(m => ({ default: m.SubjectView })));
const SubjectGroupings = lazy(() => import('./pages/SubjectPage').then(m => ({ default: m.SubjectGroupings })));
const LessonCreationForm = lazy(() => import('./components/lesson/createlesson/LessonCreationForm'));
const LessonPage = lazy(() => import('./pages/LessonPage2.0/hooks/LessonPage').then(m => ({ default: m.LessonPage })));
const LessonEditView = lazy(() => import('./pages/LessonPage2.0/LessonEditView/LessonEditView').then(m => ({ default: m.LessonEditView })));

// --- Lazy Loaded Assessment Components ---
const Assessment = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.Assessment })));
const CreatePDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.CreatePDF })));
const CreateManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.CreateManual })));
const EditPDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.EditPDF })));
const EditManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.EditManual })));
const AnswerPDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.AnswerPDF })));
const AnswerManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.AnswerManual })));
const EditAssignPDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.EditAssignPDF })));
const ViewPDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.ViewPDF })));
const ViewManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.ViewManual })));
const StudentAssessment = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.StudentAssessment })));
const StudentViewPDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.StudentViewPDF })));
const StudentViewManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.StudentViewManual })));
const Tracker = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.Tracker })));
const TeacherViewPDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.TeacherViewPDF })));
const TeacherViewManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.TeacherViewManual })));
const PreviewPDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.PreviewPDF })));
const PreviewManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.PreviewManual })));
const AssessmentSubjects = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.AssessmentSubjects })));
const StudentAssessmentSubjects = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.StudentAssessmentSubjects })));
const DiagnosticAssessmentReport = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.DiagnosticAssessmentReport })));
const FormativeAssessment = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.FormativeAssessment })));
const FormativeCreateManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.FormativeCreateManual })));
const FormativeCreatePDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.FormativeCreatePDF })));
const FormativeEditManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.FormativeEditManual })));
const FormativeEditPDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.FormativeEditPDF })));
const FormativeAnswerManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.FormativeAnswerManual })));
const FormativeAnswerPDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.FormativeAnswerPDF })));
const FormativePreviewManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.FormativePreviewManual })));
const FormativePreviewPDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.FormativePreviewPDF })));
const FormativeTracker = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.FormativeTracker })));
const FormativeViewManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.FormativeViewManual })));
const StudentFormativeViewManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.StudentFormativeViewManual })));
const StudentFormativeViewPDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.StudentFormativeViewPDF })));
const TeacherFormativeViewPDF = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.TeacherFormativeViewPDF })));
const TeacherFormativeViewManual = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.TeacherFormativeViewManual })));
const FormativeAssessmentSubjects = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.FormativeAssessmentSubjects })));
const StudentFormativeAssessment = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.StudentFormativeAssessment })));
const StudentFormativeAssessmentSubjects = lazy(() => import('./pages/AssessmentPage').then(m => ({ default: m.StudentFormativeAssessmentSubjects })));

function App() {
   const { pathname } = useLocation();
   const isPublicPath = pathname === "/" || pathname === "/application" || pathname === "/privacy-policy" || pathname === "/forgot-password";
   const noticeBoardHiddenRoutes = new Set([
      '/assessment',
      '/formativeassessment',
      '/microcredsassessment',
      '/bdiagnostic',
      '/studentassessment',
      '/studentmicrocredsassessment',
      '/bdiagnostic/student',
      '/studenthomeworks',
      '/studentmicrocredentials/homeworks',
      '/studentmicrocredentials/performance-tasks',
      '/studentmicrocredentials/written-works',
      '/studentformativeassessment',
      '/studentmasteryassessment',
      '/microcredentials/homeworks/list',
      '/microcredentials/performance-tasks/course',
      '/microcredentials/written-works/course',
      '/microcredentials/student-performance-tasks',
   ]);
   const shouldHideNoticeBoardSlide =
      noticeBoardHiddenRoutes.has(pathname)
      || /\/(answer-(manual|pdf)|(create|edit)-(manual|pdf)(-assign)?)$/.test(pathname);

   // TVET overlay: a CampusCloud page whose tables the TVET campus databases lack is replaced by an
   // explanation instead of loading a form that can only come back empty. See misc/TvetTenant.js.
   const unavailableFeature = getUnavailableFeature(pathname);

   return (
      <div>
         {!isPublicPath && !shouldHideNoticeBoardSlide && <NoticeBoardSlide />}
         {!isPublicPath
            ?
            <>
               <SideMenuNew />
               <SideMenuSmallScreenNew />
               <main className="main-wrapper">
                  <Suspense fallback={<div className="loading-spinner">Loading...</div>}>
                  {unavailableFeature ? (
                     <TvetFeatureUnavailable feature={unavailableFeature} />
                  ) : (
                  <Routes>
                     <Route path="/home" element={<Dashboard />} />
                     <Route path="/announcement" element={<NoticeBoard />} />
                     <Route path="/test" element={<LessonViewerTest />} />
                     <Route path="/profile" element={<Profile />} />

                     <Route path="/notice" element={<NoticeList />} />
                     <Route path="/notice/create" element={<CreateNotice />} />
                     <Route path="/notice/edit" element={<EditNotice />} />
                     <Route path="/schedule" element={<Schedules />} />

                     <Route path="/lesson/createlesson" element={<LessonCreationForm mode="add" />} />
                     <Route path="/lesson/editlesson" element={<LessonCreationForm mode="edit" />} />
                     <Route path="/subject" element={<SubjectGroupings />} />
                     <Route path="/subject/edit/lesson" element={<LessonPage />} />
                     <Route path="/subject/edit" element={<LessonEditView mode="edit" />} />
                     <Route path="/subject/view" element={<LessonEditView mode="view" />} />

                     <Route path="/microcredentials/teacher-guide" element={<MicrocredentialsTeacherGuidePage />} />
                     <Route path="/microcredentials/homeworks" element={<HomeworkSubjects type="microcredential" isMicrocredentials={true} />} />
                     <Route path="/microcredentials/homeworks/list" element={<Homeworks type="microcredential" isMicrocredentials={true} />} />
                     <Route path="/microcredentials/performance-tasks" element={<MicrocredentialsPerformanceTaskCoursesPage />} />
                     <Route path="/microcredentials/performance-tasks/course" element={<MicrocredentialsPerformanceTaskPage />} />
                     <Route path="/microcredentials/written-works" element={<MicrocredentialsWrittenWorksCoursesPage />} />
                     <Route path="/microcredentials/written-works/course" element={<MicrocredentialsWrittenWorksPage />} />

                     <Route path="/activities" element={<Dashboard />} />
                     <Route path="/assignment" element={<Dashboard />} />

                     <Route path="/brainee-resources" element={<SubjectGroupingsResources />} />

                     <Route path="/assessment" element={<Assessment />} />
                     <Route path="/assessment/create-pdf" element={<CreatePDF />} />
                     <Route path="/assessment/create-manual" element={<CreateManual />} />
                     <Route path="/assessment/edit-pdf" element={<EditPDF />} />
                     <Route path="/assessment/edit-manual" element={<EditManual />} />
                     <Route path="/assessment/answer-pdf" element={<AnswerPDF />} />
                     <Route path="/assessment/answer-manual" element={<AnswerManual />} />
                     <Route path="/assessment/edit-pdf-assign" element={<EditAssignPDF />} />
                     <Route path="/assessment/view-pdf" element={<ViewPDF />} />
                     <Route path="/assessment/view-manual" element={<ViewManual />} />
                     <Route path="/assessment/preview-pdf" element={<PreviewPDF />} />
                     <Route path="/assessment/preview-manual" element={<PreviewManual />} />
                     <Route path="/assessment/subjects" element={<AssessmentSubjects />} />

                     <Route path="/studentassessment" element={<StudentAssessment />} />
                     <Route path="/studentassessment/view-ans-pdf" element={<StudentViewPDF />} />
                     <Route path="/studentassessment/view-ans-manual" element={<StudentViewManual />} />
                     <Route path="/studentassessment/subjects" element={<StudentAssessmentSubjects />} />

                     <Route path="/masteryassessment/create" element={<MasteryCreate />} />
                     <Route path="/masteryassessment/edit" element={<MasteryEdit />} />
                     <Route path="/masteryassessment/preview" element={<MasteryPreview />} />
                     <Route path="/masterycontents" element={<MasteryContents />} />
                     <Route path="/masteryassessment" element={<MasteryAssessment />} />
                     <Route path="/masteryassessmentsubject" element={<MasteryAssessmentSubject />} />
                     <Route path="/masteryassessment/create-pdf" element={<MasteryCreatePDF />} />
                     <Route path="/masteryassessment/create-manual" element={<MasteryCreateManual />} />
                     <Route path="/masteryassessment/edit-pdf" element={<MasteryEditPDF />} />
                     <Route path="/masteryassessment/edit-manual" element={<MasteryEditManual />} />
                     <Route path="/masteryassessment/preview-pdf" element={<MasteryPreviewPDF />} />
                     <Route path="/masteryassessment/preview-manual" element={<MasteryPreviewManual />} />
                     <Route path="/masteryassessment/answer-pdf" element={<MasteryAnswerPDF />} />
                     <Route path="/masteryassessment/answer-manual" element={<MasteryAnswerManual />} />
                     <Route path="/masteryassessment/study-plan" element={<MasteryStudyPlan />} />
                     <Route path="/masteryassessment/tracker" element={<MasteryTracker />} />
                     <Route path="/masteryassessment/teacher-view-ans-pdf" element={<MasteryTeacherViewPDF />} />
                     <Route path="/masteryassessment/teacher-view-ans-manual" element={<MasteryTeacherViewManual />} />
                     <Route path="/masteryassessment/student-view-ans-pdf" element={<MasteryStudentViewPDF />} />
                     <Route path="/masteryassessment/student-view-ans-manual" element={<MasteryStudentViewManual />} />
                     <Route path="/masteryassessment/view-recommendation" element={<MasteryRecommendation />} />
                     <Route path="/masteryassessmentreport" element={<MasteryAssessmentReport />} />
                     <Route path="/masteryreport1" element={<MasteryReportType1 />} />
                     <Route path="/masteryreport2" element={<MasteryReportType2 />} />
                     <Route path="/masteryreport3" element={<MasteryReportType3 />} />
                     <Route path="/masteryreport4" element={<MasteryReportType4 />} />
                     <Route path="/masteryreport5" element={<MasteryReportType5 />} />
                     <Route path="/masteryassessment/view-instruction" element={<MasteryInstruction />} />
                     <Route path="/masterysubjects" element={<MasterySubjects />} />

                     <Route path="/studentmasteryassessment" element={<MasteryStudentAssessment />} />
                     <Route path="/studentmasteryassessment/preview" element={<MasteryStudentPreview />} />
                     <Route path="/studentmasteryassessment/view-result" element={<MasteryStudentViewResult />} />

                     <Route path="/assessmenttracker" element={<Tracker />} />
                     <Route path="/assessmenttracker/teacher-view-ans-pdf" element={<TeacherViewPDF />} />
                     <Route path="/assessmenttracker/teacher-view-ans-manual" element={<TeacherViewManual />} />

                     <Route path="/formativeassessment" element={<FormativeAssessment />} />
                     <Route path="/formativeassessment/create-manual" element={<FormativeCreateManual />} />
                     <Route path="/formativeassessment/create-pdf" element={<FormativeCreatePDF />} />
                     <Route path="/formativeassessment/edit-manual" element={<FormativeEditManual />} />
                     <Route path="/formativeassessment/edit-pdf" element={<FormativeEditPDF />} />
                     <Route path="/formativeassessment/answer-manual" element={<FormativeAnswerManual />} />
                     <Route path="/formativeassessment/answer-pdf" element={<FormativeAnswerPDF />} />
                     <Route path="/formativeassessment/view-manual" element={<FormativeViewManual />} />
                     <Route path="/formativeassessment/preview-manual" element={<FormativePreviewManual />} />
                     <Route path="/formativeassessment/preview-pdf" element={<FormativePreviewPDF />} />
                     <Route path="/formativeassessmenttracker" element={<FormativeTracker />} />
                     <Route path="/formativeassessmenttracker/teacher-view-ans-pdf" element={<TeacherFormativeViewPDF />} />
                     <Route path="/formativeassessmenttracker/teacher-view-ans-manual" element={<TeacherFormativeViewManual />} />
                     <Route path="/formativeassessment/subjects" element={<FormativeAssessmentSubjects />} />

                     <Route path="/studentformativeassessment" element={<StudentFormativeAssessment />} />
                     <Route path="/studentformativeassessment/view-ans-manual" element={<StudentFormativeViewManual />} />
                     <Route path="/studentformativeassessment/view-ans-pdf" element={<StudentFormativeViewPDF />} />
                     <Route path="/studentformativeassessment/subjects" element={<StudentFormativeAssessmentSubjects />} />

                     <Route path="/microcredsassessment" element={<Assessment />} />
                     <Route path="/microcredsassessment/create-pdf" element={<CreatePDF />} />
                     <Route path="/microcredsassessment/create-manual" element={<CreateManual />} />
                     <Route path="/microcredsassessment/edit-pdf" element={<EditPDF />} />
                     <Route path="/microcredsassessment/edit-manual" element={<EditManual />} />
                     <Route path="/microcredsassessment/answer-pdf" element={<AnswerPDF />} />
                     <Route path="/microcredsassessment/answer-manual" element={<AnswerManual />} />
                     <Route path="/microcredsassessment/edit-pdf-assign" element={<EditAssignPDF />} />
                     <Route path="/microcredsassessment/view-pdf" element={<ViewPDF />} />
                     <Route path="/microcredsassessment/view-manual" element={<ViewManual />} />
                     <Route path="/microcredsassessment/preview-pdf" element={<PreviewPDF />} />
                     <Route path="/microcredsassessment/preview-manual" element={<PreviewManual />} />
                     <Route path="/microcredsassessment/subjects" element={<AssessmentSubjects />} />

                     <Route path="/studentmicrocredsassessment" element={<StudentAssessment />} />
                     <Route path="/studentmicrocredsassessment/view-ans-pdf" element={<StudentViewPDF />} />
                     <Route path="/studentmicrocredsassessment/view-ans-manual" element={<StudentViewManual />} />
                     <Route path="/studentmicrocredsassessment/subjects" element={<StudentAssessmentSubjects />} />

                     <Route path="/microcredstracker" element={<Tracker />} />
                     <Route path="/microcredstracker/teacher-view-ans-pdf" element={<TeacherViewPDF />} />
                     <Route path="/microcredstracker/teacher-view-ans-manual" element={<TeacherViewManual />} />

                     <Route path="/microcredentials-management" element={<MicrocredentialsManagementPage />} />

                     <Route path="/homeworks" element={<Homeworks />} />
                     <Route path="/projects" element={<Projects />} />
                     <Route path="/studenthomeworks" element={<StudentHomeworks />} />
                     <Route path="/homeworksubjects" element={<HomeworkSubjects />} />
                     <Route path="/projectsubjects" element={<ProjectSubjects />} />
                     <Route path="/studenthomeworks/subjects" element={<StudentHomeworkSubjects />} />
                     <Route path="/studentmicrocredentials/homeworks" element={<StudentHomeworks type="microcredential" isMicrocredentials={true} />} />
                     <Route path="/studentmicrocredentials/homeworks/subjects" element={<StudentHomeworkSubjects type="microcredential" isMicrocredentials={true} />} />
                     <Route path="/studentmicrocredentials/performance-tasks" element={<MicrocredentialsStudentPerformanceTaskPage />} />
                     <Route path="/studentmicrocredentials/performance-tasks/subjects" element={<MicrocredentialsStudentPerformanceTaskSubjectsPage />} />
                     <Route path="/studentmicrocredentials/written-works" element={<MicrocredentialsStudentWrittenWorksPage />} />
                     <Route path="/studentmicrocredentials/written-works/subjects" element={<MicrocredentialsStudentWrittenWorksSubjectsPage />} />

                     <Route path="/reportcards" element={<ReportCards />} />
                     <Route path="/studentreportcard" element={<StudentReportCards />} />
                     <Route path="/certificates" element={<Certificates />} />
                     <Route path="/studentcertificate" element={<StudentCertificates />} />

                     <Route path="/managestudentinfo" element={<StudentInfo />} />
                     <Route path="/managestaffinfo" element={<StaffInfo />} />
                     <Route path="/promotestudents" element={<PromoteStudents />} />
                     <Route path="/sections" element={<Sections />} />
                     <Route path="/levels" element={<Levels />} />
                     <Route path="/subjects" element={<Subjects />} />
                     <Route path="/subjectgroups" element={<SubjectGroups />} />
                     <Route path="/configsettings" element={<ConfigSettings />} />

                     <Route path="/classsched" element={<ClassSchedule />} />
                     <Route path="/lessoncalendar" element={<LessonCalendar />} />
                     <Route path="/schoolcalendar" element={<SchoolCalendar />} />

                     <Route path="/surveyassign" element={<SurveyAssign />} />
                     <Route path="/survey" element={<Survey />} />

                     <Route path="/attendance" element={<Attendance />} />
                     <Route path="/classroomattendance" element={<ClassroomAttendance />} />
                     <Route path="/classroomattendancerpt" element={<ClassroomAttendanceReports />} />
                     <Route path="/periodattendance" element={<PeriodAttendance />} />
                     <Route path="/periodattendancerpt" element={<PeriodAttendanceReport />} />


                     <Route path="/bdiagnostic" element={<Assessment />} />
                     <Route path="/bdiagnostic/create-pdf" element={<CreatePDF />} />
                     <Route path="/bdiagnostic/edit-pdf" element={<EditPDF />} />
                     <Route path="/bdiagnostic/create-manual" element={<CreateManual />} />
                     <Route path="/bdiagnostic/edit-manual" element={<EditManual />} />
                     <Route path="/bdiagnostic/preview-pdf" element={<PreviewPDF />} />
                     <Route path="/bdiagnostic/preview-manual" element={<PreviewManual />} />
                     <Route path="/bdiagnostic/view-manual" element={<ViewManual />} />
                     <Route path="/bdiagnostic/view-pdf" element={<ViewPDF />} />
                     <Route path="/bdiagnostic/tracker" element={<Tracker />} />
                     <Route path="/bdiagnostic/student" element={<StudentAssessment />} />
                     <Route path="/bdiagnostic/student/answer-pdf" element={<AnswerPDF />} />
                     <Route path="/bdiagnostic/student/answer-manual" element={<AnswerManual />} />
                     <Route path="/bdiagnostic/student/view-ans-pdf" element={<StudentViewPDF />} />
                     <Route path="/bdiagnostic/student/view-ans-manual" element={<StudentViewManual />} />
                     <Route path="/bdiagnostic/teacher/view-ans-pdf" element={<TeacherViewPDF />} />
                     <Route path="/bdiagnostic/teacher/view-ans-manual" element={<TeacherViewManual />} />
                     <Route path="/bdiagnostic/tracker/teacher-view-ans-pdf" element={<TeacherViewPDF />} />
                     <Route path="/bdiagnostic/tracker/teacher-view-ans-manual" element={<TeacherViewManual />} />
                     <Route path="/bdiagnostic/report" element={<DiagnosticAssessmentReport />} />
                     <Route path="/bdiagnostic/subjects" element={<AssessmentSubjects />} />
                     <Route path="/bdiagnostic/student/subjects" element={<StudentAssessmentSubjects />} />

                     <Route path="/applicantlist" element={<ApplicationList />} />
                     <Route path="/applicantsbybatch" element={<ApplicantListByBatch />} />
                     <Route path="/reviewapplication" element={<ReviewApplication />} />
                     <Route path="/interview" element={<Interview />} />
                     <Route path="/upload-docs" element={<ApplicantMER />} />
                     <Route path="/review-docs" element={<ReviewMER />} />
                     <Route path="/appinfogroups" element={<OnlineAppInfoGroups />} />
                     <Route path="/appinfofields" element={<OnlineAppInfoFields />} />
                     <Route path="/studentprofile" element={<StudentProfile />} />
                     <Route path="/studentfees" element={<StudentFees />} />
                     <Route path="/soa" element={<Soa />} />
                     <Route path="/admission" element={<OldStudentAdmission />} />

                     <Route path="/studentemergencyinfo" element={<StudentEmergencyInfo />} />

                  </Routes>
                  )}
                  </Suspense>
               </main>
            </>
            :
            <>
               <main className="main-wrapper2">
                  <Routes>
                     <Route path="/" element={<Login />} />
                     <Route path="/forgot-password" element={<ForgotPassword />} />
                     <Route path="/application" element={<Application />} />
                     <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  </Routes>
               </main>
            </>}

      </div>
   );
}

export default App;
